import apiClient from "../core/HttpClient";
import HttpClient from "../core/HttpClient";
import { PaginationResult } from "../lib/definitions";
import { Membership, User } from "../models";
import { MembershipViewModel } from "../viewModels";
 
export default class MemberShipService {
  // Define methods for user-related operations
  url = "/memberships";
  async getMemberships():Promise<MembershipViewModel[]> {
    return apiClient
      .get<Membership[]>(this.url)
      .then((response) => {
        return response.data;
      });
  }
async getMembershipById(id:string):Promise<MembershipViewModel> {
    return apiClient
      .get<Membership>(this.url+`/${id}`)
      .then((response) => {
        return response.data;
      });
  }
  async deleteMembership(id: string) {
    return apiClient.delete(`${this.url}/${id}`)
  }
  async createMembership(data: Membership) {
    return apiClient.post(this.url, data);
  }
  async updateMembership(id: string, data: Membership) {
    return apiClient.put(`${this.url}/${id}`, data).then((response) => {
      return response.data;
    });
  }
  
}
